var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-row",
        { attrs: { type: "flex", justify: "center" } },
        [
          _c(
            "vxe-button",
            {
              attrs: { size: "mini", status: "primary" },
              on: {
                click: function ($event) {
                  return _vm.print()
                },
              },
            },
            [_vm._v(" 打印 ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { ref: "batchPrintArea" },
        _vm._l(_vm.batchPrintData, function (item, indexs) {
          return _c(
            "div",
            {
              key: indexs,
              staticClass: "printClass",
              staticStyle: { "page-break-after": "always" },
            },
            [
              _c(
                "a-row",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { type: "flex", justify: "center" },
                },
                [
                  _c(
                    "table",
                    {
                      staticStyle: { "border-collapse": "collapse" },
                      attrs: {
                        border: "1",
                        cellspacing: "0",
                        cellpadding: "0",
                      },
                    },
                    [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticClass: "table-name",
                            attrs: { colspan: "7" },
                          },
                          [_vm._v("客户信息档案表")]
                        ),
                      ]),
                      _c("tr", [
                        _c(
                          "th",
                          { staticClass: "td3", attrs: { rowspan: "3" } },
                          [_vm._v("车辆信息")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("品系")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.strainName))]
                        ),
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("购车时间")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.e3sDeliveryDate))]
                        ),
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("底盘号")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.batholithNo))]
                        ),
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("车型代码")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.modelCode))]
                        ),
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("所属经理部")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.regionName))]
                        ),
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("经销商")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.dealerName))]
                        ),
                      ]),
                      _c("tr", [
                        _c(
                          "th",
                          { staticClass: "td3", attrs: { rowspan: "7" } },
                          [_vm._v("客户信息")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("姓名")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.custName))]
                        ),
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("性别")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.sexName))]
                        ),
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("电话")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.mobile))]
                        ),
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("民族")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.nationName))]
                        ),
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("身份证")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.idCard))]
                        ),
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("出生日期")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.birthday))]
                        ),
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("行业")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.industryName))]
                        ),
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("客户类型")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.custCategoryName))]
                        ),
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("是否乘龙老友")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.isOldFriendName))]
                        ),
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("职位")]
                        ),
                        _c("td", {
                          staticClass: "td2",
                          attrs: { colspan: "2" },
                        }),
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("省份")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.provinceName))]
                        ),
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("市")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.cityName))]
                        ),
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("区")]
                        ),
                        _c(
                          "td",
                          { staticClass: "td2", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.districtName))]
                        ),
                        _c(
                          "td",
                          { staticClass: "td1", attrs: { colspan: "1" } },
                          [_vm._v("详细地址")]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "td2",
                            staticStyle: {
                              "text-align": "left",
                              "padding-left": "10px",
                            },
                            attrs: { colspan: "2" },
                          },
                          [_vm._v(_vm._s(item.address))]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }